import Vue from "vue";

export default {
  getLeaveReport({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        ...state.reportParams,
        page: state.currentPage,
        perPage: state.perPage,
      };

      Vue.$http
        .get("/hrm/reports/generate-leave-usage-reports", { params })
        .then(response => {
          commit("employeeData", response.data.reports);
          commit("leaveData", response.data);
          commit("reportTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  downloadReport({ commit, state }) {
    const params = {
      ...state.reportParams,
      page: state.currentPage,
      perPage: state.perPage,
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/reports/download-leave-usage-reports`, { params })
        .then(response => {
          commit("tableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  getBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          commit("branches", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getDepartments({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("organization/departments")
        .then(response => {
          commit("departments", response.data);
          resolve(response.data.results);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getLeaveTypes({ commit, state }) {
    return new Promise((resolve, reject) => {
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
      };

      Vue.$http
        .get("/hrm/leaves/settings/leavetypes", { params })
        .then(response => {
          commit("leaveTypes", response.data.results);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getExemptionReport({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);
      const params = {
        ...state.reportParams,
        ...(payload && payload),
        // page: state.currentPage,
        // perPage: state.perPage
      };

      Vue.$http
        .get("/hrm/reports/generate-exemption-usage-reports", { params })
        .then(response => {
          commit("exemptionData", response.data.results);
          commit("exemptionReportTotal", response.data.total);
          commit("tableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  downloadExemptionReport({ commit, state }) {
    const params = {
      ...state.reportParams,
      page: state.currentPage,
      perPage: state.perPage,
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/reports/download-exemption-usage-summary`, { params })
        .then(response => {
          commit("tableLoading", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getLeaveReport");
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getLeaveReport");
  },
  handleCurrentChangeExemption({ commit, dispatch, state }, page) {
    commit("currentPageExemption", page);
    dispatch("getExemptionReport", {
      perPage: state.perPageExemption,
      page: state.currentPageExemption,
    });
  },
  handleSizeChangeExemption({ commit, dispatch, state }, perPage) {
    commit("perPageExemption", perPage);
    commit("currentPageExemption", 1);
    dispatch("getExemptionReport", {
      perPage: state.perPageExemption,
      page: state.currentPageExemption,
    });
  },
};
